import type { SurveyQuestion } from '../types/survey';

export const QUESTIONS: SurveyQuestion[] = [
  {
    id: 1,
    question: {
      fr: "Quel geste permet d'économiser le plus d'eau pendant la vaisselle ?",
      ar: 'ما التصرف الذي يسمح بتوفير أكبر كمية من الماء أثناء غسل الأواني؟',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: 'Utiliser plus de mousse',
          ar: 'استخدام كمية أكبر من الرغوة',
        },
      },
      {
        id: 2,
        text: {
          fr: 'Fermer le robinet pendant le savonnage',
          ar: 'غلق الصنبور أثناء وضع الصابون',
        },
      },
      {
        id: 3,
        text: {
          fr: "Utiliser plus d'eau chaude",
          ar: 'استخدام كمية أكبر من الماء الساخن',
        },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: "Fermer le robinet pendant le savonnage peut permettre d'économiser plusieurs dizaines de litres d'eau à chaque vaisselle.",
      ar: 'يمكن لغلق الصنبور أثناء وضع الصابون أن يوفر عشرات اللترات من الماء في كل مرة يتم فيها غسل الأواني.',
    },
    tip: {
      fr: "Ne laissez couler l'eau que pendant le rinçage.",
      ar: 'لا تترك الماء جارياً إلا أثناء الشطف.',
    },
  },
  {
    id: 2,
    question: {
      fr: 'Un robinet laissé ouvert peut consommer environ :',
      ar: 'يمكن لصنبور متروك مفتوحاً أن يستهلك حوالي:',
    },
    answers: [
      {
        id: 1,
        text: { fr: '2 litres/minute', ar: 'لترين في الدقيقة' },
      },
      {
        id: 2,
        text: { fr: '5 litres/minute', ar: '5 لترات في الدقيقة' },
      },
      {
        id: 3,
        text: { fr: '12 litres/minute', ar: '12 لتراً في الدقيقة' },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: "Un simple robinet ouvert pendant quelques minutes peut gaspiller autant d'eau qu'une personne boit en plusieurs jours.",
      ar: 'قد يهدر صنبور مفتوح لبضع دقائق كمية من الماء تعادل ما يشربه شخص خلال عدة أيام.',
    },
    tip: {
      fr: 'Fermez toujours le robinet lorsque vous ne rincez pas.',
      ar: 'أغلق الصنبور دائماً عندما لا تقوم بالشطف.',
    },
  },
  {
    id: 3,
    question: {
      fr: "Pourquoi est-il important d'économiser l'eau ?",
      ar: 'لماذا من المهم الاقتصاد في استهلاك الماء؟',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: 'Pour faire plus de mousse',
          ar: 'للحصول على رغوة أكثر',
        },
      },
      {
        id: 2,
        text: {
          fr: "Parce que l'eau est une ressource précieuse",
          ar: 'لأن الماء مورد ثمين',
        },
      },
      {
        id: 3,
        text: {
          fr: 'Pour salir moins de vaisselle',
          ar: 'لتقليل اتساخ الأواني',
        },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: "Moins de 3 % de l'eau présente sur Terre est de l'eau douce utilisable par l'être humain.",
      ar: 'أقل من 3٪ من المياه الموجودة على الأرض هي مياه عذبة قابلة للاستعمال من طرف الإنسان.',
    },
    tip: {
      fr: "Chaque geste quotidien peut contribuer à préserver l'eau.",
      ar: 'كل تصرف يومي يمكن أن يساهم في الحفاظ على الماء.',
    },
  },
  {
    id: 4,
    question: {
      fr: "Quelle méthode permet de réduire la consommation d'eau ?",
      ar: 'ما الطريقة التي تساعد على تقليل استهلاك الماء؟',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: 'Rincer chaque assiette séparément',
          ar: 'شطف كل طبق بشكل منفصل',
        },
      },
      {
        id: 2,
        text: {
          fr: 'Regrouper la vaisselle avant le rinçage',
          ar: 'جمع الأواني قبل الشطف',
        },
      },
      {
        id: 3,
        text: {
          fr: 'Utiliser deux robinets',
          ar: 'استخدام صنبورين',
        },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: "Une vaisselle organisée permet de gagner du temps et de réduire considérablement la consommation d'eau.",
      ar: 'يساعد تنظيم الأواني على ربح الوقت وتقليل استهلاك الماء بشكل كبير.',
    },
    tip: {
      fr: 'Savonnez toute la vaisselle avant de commencer le rinçage.',
      ar: 'ضع الصابون على جميع الأواني قبل البدء في الشطف.',
    },
  },
  {
    id: 5,
    question: {
      fr: "Chaque goutte d'eau économisée est :",
      ar: 'كل قطرة ماء يتم توفيرها هي:',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'Sans importance', ar: 'غير مهمة' },
      },
      {
        id: 2,
        text: {
          fr: 'Utile pour préserver les ressources',
          ar: 'مفيدة للحفاظ على الموارد',
        },
      },
      {
        id: 3,
        text: {
          fr: 'Impossible à mesurer',
          ar: 'من المستحيل قياسها',
        },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: "Les petits gestes répétés chaque jour ont un impact important sur l'environnement.",
      ar: 'للتصرفات الصغيرة المتكررة يومياً تأثير كبير على البيئة.',
    },
    tip: {
      fr: "Adoptez de bonnes habitudes, même lorsqu'elles semblent minimes.",
      ar: 'اعتمد عادات جيدة حتى وإن بدت بسيطة.',
    },
  },
  {
    id: 6,
    question: {
      fr: 'Quel ustensile est généralement le plus difficile à dégraisser ?',
      ar: 'ما الأداة التي يكون عادةً من الأصعب إزالة الدهون منها؟',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'Une tasse', ar: 'فنجان' },
      },
      {
        id: 2,
        text: { fr: 'Un verre', ar: 'كأس' },
      },
      {
        id: 3,
        text: { fr: 'Une poêle', ar: 'مقلاة' },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: 'Les huiles de cuisson et les fritures créent les résidus les plus difficiles à éliminer.',
      ar: 'تترك زيوت الطهي والقلي بقايا دهنية تعد من الأصعب في الإزالة.',
    },
    tip: {
      fr: 'Nettoyez les poêles rapidement avant que la graisse ne sèche.',
      ar: 'نظّف المقالي بسرعة قبل أن تجف الدهون.',
    },
  },
  {
    id: 7,
    question: {
      fr: 'Quel est le meilleur moment pour faire la vaisselle ?',
      ar: 'ما أفضل وقت لغسل الأواني؟',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'Le lendemain', ar: 'في اليوم التالي' },
      },
      {
        id: 2,
        text: {
          fr: 'Plusieurs heures après',
          ar: 'بعد عدة ساعات',
        },
      },
      {
        id: 3,
        text: {
          fr: 'Juste après le repas',
          ar: 'مباشرة بعد الوجبة',
        },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: 'Plus les résidus alimentaires restent longtemps sur la vaisselle, plus ils deviennent difficiles à nettoyer.',
      ar: 'كلما بقيت بقايا الطعام مدة أطول على الأواني، أصبح تنظيفها أكثر صعوبة.',
    },
    tip: {
      fr: 'Lavez ou faites tremper la vaisselle immédiatement après le repas.',
      ar: 'اغسل الأواني أو انقعها مباشرة بعد الوجبة.',
    },
  },
  {
    id: 8,
    question: {
      fr: 'En moyenne, combien de couverts une famille de 4 personnes utilise-t-elle par repas ?',
      ar: 'في المتوسط، كم قطعة من أدوات المائدة تستعملها عائلة من 4 أشخاص في الوجبة؟',
    },
    answers: [
      {
        id: 1,
        text: { fr: '4', ar: '4' },
      },
      {
        id: 2,
        text: { fr: '8', ar: '8' },
      },
      {
        id: 3,
        text: { fr: 'Plus de 12', ar: 'أكثر من 12' },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: 'Entre les assiettes, verres, fourchettes, cuillères et plats de service, le nombre de pièces à laver augmente très vite.',
      ar: 'بين الأطباق والكؤوس والشوك والملاعق وأواني التقديم، يرتفع عدد القطع التي يجب غسلها بسرعة.',
    },
    tip: {
      fr: 'Regroupez les pièces similaires pour faciliter le nettoyage.',
      ar: 'اجمع القطع المتشابهة لتسهيل عملية التنظيف.',
    },
  },
  {
    id: 9,
    question: {
      fr: "Quel est le principal ennemi d'une vaisselle propre ?",
      ar: 'ما العدو الرئيسي لنظافة الأواني؟',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'Le sucre', ar: 'السكر' },
      },
      {
        id: 2,
        text: { fr: 'La graisse', ar: 'الدهون' },
      },
      {
        id: 3,
        text: { fr: 'Le sel', ar: 'الملح' },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: 'La graisse adhère fortement aux surfaces et nécessite un produit performant pour être éliminée efficacement.',
      ar: 'تلتصق الدهون بقوة بالأسطح وتتطلب منتجاً فعالاً لإزالتها جيداً.',
    },
    tip: {
      fr: 'Utilisez un liquide vaisselle doté d’un bon pouvoir dégraissant.',
      ar: 'استخدم سائلاً لغسل الأواني يتمتع بقدرة جيدة على إزالة الدهون.',
    },
  },
  {
    id: 10,
    question: {
      fr: 'Une vaisselle bien organisée permet :',
      ar: 'يسمح التنظيم الجيد للأواني بـ:',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: "De consommer plus d'eau",
          ar: 'استهلاك ماء أكثر',
        },
      },
      {
        id: 2,
        text: {
          fr: 'De gagner du temps',
          ar: 'ربح الوقت',
        },
      },
      {
        id: 3,
        text: {
          fr: 'D’utiliser plus de produit',
          ar: 'استخدام كمية أكبر من المنتج',
        },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: "L'organisation est l'un des meilleurs moyens de réduire le temps passé à faire la vaisselle.",
      ar: 'يعد التنظيم من أفضل الطرق لتقليل الوقت المستغرق في غسل الأواني.',
    },
    tip: {
      fr: 'Triez les verres, assiettes et ustensiles avant de commencer.',
      ar: 'رتّب الكؤوس والأطباق والأدوات قبل البدء.',
    },
  },
  {
    id: 11,
    question: {
      fr: 'Quel est le principal avantage du liquide vaisselle AIGLE ?',
      ar: 'ما الميزة الرئيسية لسائل غسل الأواني AIGLE؟',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: 'Il change de couleur',
          ar: 'يغير لونه',
        },
      },
      {
        id: 2,
        text: {
          fr: 'Il est super dégraissant',
          ar: 'يتميز بقوة فائقة لإزالة الدهون',
        },
      },
      {
        id: 3,
        text: {
          fr: 'Il mousse en permanence',
          ar: 'ينتج الرغوة باستمرار',
        },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: 'AIGLE a été développé pour éliminer efficacement les graisses les plus tenaces du quotidien.',
      ar: 'تم تطوير AIGLE لإزالة أصعب الدهون اليومية بفعالية.',
    },
    tip: {
      fr: 'Une petite quantité suffit pour profiter de son pouvoir dégraissant.',
      ar: 'تكفي كمية صغيرة للاستفادة من قدرته على إزالة الدهون.',
    },
  },
  {
    id: 12,
    question: {
      fr: 'Que signifie « super dégraissant » ?',
      ar: 'ماذا تعني عبارة «قوة فائقة لإزالة الدهون»؟',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'Plus de parfum', ar: 'عطر أكثر' },
      },
      {
        id: 2,
        text: { fr: 'Plus de mousse', ar: 'رغوة أكثر' },
      },
      {
        id: 3,
        text: {
          fr: 'Une meilleure efficacité contre les graisses',
          ar: 'فعالية أكبر ضد الدهون',
        },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: "Une meilleure efficacité permet souvent de nettoyer plus rapidement avec moins d'effort.",
      ar: 'تسمح الفعالية الأكبر بالتنظيف بسرعة أكبر وبمجهود أقل.',
    },
    tip: {
      fr: 'La quantité de mousse ne détermine pas à elle seule l’efficacité.',
      ar: 'كمية الرغوة وحدها لا تحدد فعالية المنتج.',
    },
  },
  {
    id: 13,
    question: {
      fr: "Le pouvoir dégraissant d'AIGLE agit principalement sur :",
      ar: 'تعمل قوة AIGLE لإزالة الدهون بشكل رئيسي على:',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'La poussière', ar: 'الغبار' },
      },
      {
        id: 2,
        text: {
          fr: 'Les huiles et les graisses',
          ar: 'الزيوت والدهون',
        },
      },
      {
        id: 3,
        text: { fr: 'Le calcaire', ar: 'الترسبات الكلسية' },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: 'Les huiles de cuisson figurent parmi les salissures les plus difficiles à éliminer dans une cuisine.',
      ar: 'تعد زيوت الطهي من بين أصعب الأوساخ التي يجب إزالتها في المطبخ.',
    },
    tip: {
      fr: 'Appliquez AIGLE directement sur les ustensiles très gras.',
      ar: 'ضع AIGLE مباشرة على الأدوات شديدة الدهنية.',
    },
  },
  {
    id: 14,
    question: {
      fr: 'Grâce à son efficacité, AIGLE permet de :',
      ar: 'بفضل فعاليته، يسمح AIGLE بـ:',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: "Utiliser plus d'eau",
          ar: 'استخدام ماء أكثر',
        },
      },
      {
        id: 2,
        text: {
          fr: 'Gagner du temps lors du nettoyage',
          ar: 'ربح الوقت أثناء التنظيف',
        },
      },
      {
        id: 3,
        text: {
          fr: 'Utiliser davantage de produit',
          ar: 'استخدام كمية أكبر من المنتج',
        },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: 'Un produit performant réduit le temps consacré aux tâches ménagères.',
      ar: 'يساعد المنتج الفعال على تقليل الوقت المخصص للأعمال المنزلية.',
    },
    tip: {
      fr: 'Respectez le dosage nécessaire pour nettoyer sans gaspillage.',
      ar: 'استخدم الجرعة اللازمة للتنظيف دون تبذير.',
    },
  },
  {
    id: 15,
    question: {
      fr: "Une petite quantité d'AIGLE permet :",
      ar: 'تسمح كمية صغيرة من AIGLE بـ:',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: 'De laver moins de vaisselle',
          ar: 'غسل عدد أقل من الأواني',
        },
      },
      {
        id: 2,
        text: {
          fr: 'De nettoyer efficacement plusieurs pièces',
          ar: 'تنظيف عدة قطع بفعالية',
        },
      },
      {
        id: 3,
        text: {
          fr: "D'augmenter la consommation",
          ar: 'زيادة الاستهلاك',
        },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: 'Un produit concentré aide à limiter le gaspillage tout en restant efficace.',
      ar: 'يساعد المنتج المركز على تقليل التبذير مع الحفاظ على فعاليته.',
    },
    tip: {
      fr: 'Commencez par une petite quantité et ajoutez-en uniquement si nécessaire.',
      ar: 'ابدأ بكمية صغيرة وأضف المزيد فقط عند الحاجة.',
    },
  },
  {
    id: 16,
    question: {
      fr: 'AIGLE est enrichi en :',
      ar: 'AIGLE غني بـ:',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'Calcium', ar: 'الكالسيوم' },
      },
      {
        id: 2,
        text: { fr: 'Vitamines', ar: 'الفيتامينات' },
      },
      {
        id: 3,
        text: { fr: 'Caféine', ar: 'الكافيين' },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: 'La formule multivitaminée a été pensée pour accompagner le soin quotidien des mains.',
      ar: 'صُممت التركيبة متعددة الفيتامينات للمساهمة في العناية اليومية باليدين.',
    },
    tip: {
      fr: 'Choisissez une formule qui associe efficacité et soin des mains.',
      ar: 'اختر تركيبة تجمع بين الفعالية والعناية باليدين.',
    },
  },
  {
    id: 17,
    question: {
      fr: 'Pourquoi les vitamines sont-elles présentes dans la formule ?',
      ar: 'لماذا تحتوي التركيبة على الفيتامينات؟',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: 'Pour changer la couleur',
          ar: 'لتغيير اللون',
        },
      },
      {
        id: 2,
        text: {
          fr: 'Pour contribuer à la douceur des mains',
          ar: 'للمساهمة في الحفاظ على نعومة اليدين',
        },
      },
      {
        id: 3,
        text: {
          fr: 'Pour faire plus de mousse',
          ar: 'لإنتاج رغوة أكثر',
        },
      },
    ],
    correctAnswer: 2,
    explanation: {
      fr: "Les mains sont exposées quotidiennement à l'eau et aux produits de nettoyage. AIGLE aide à préserver leur douceur.",
      ar: 'تتعرض اليدان يومياً للماء ومنتجات التنظيف، ويساعد AIGLE على الحفاظ على نعومتهما.',
    },
    tip: {
      fr: 'Rincez et séchez vos mains après avoir terminé la vaisselle.',
      ar: 'اشطف يديك وجففهما بعد الانتهاء من غسل الأواني.',
    },
  },
  {
    id: 18,
    question: {
      fr: 'Quelle caractéristique distingue également AIGLE ?',
      ar: 'ما الخاصية الأخرى التي تميز AIGLE؟',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: 'Son emballage uniquement',
          ar: 'عبوته فقط',
        },
      },
      {
        id: 2,
        text: {
          fr: 'Son parfum uniquement',
          ar: 'عطره فقط',
        },
      },
      {
        id: 3,
        text: {
          fr: 'Sa douceur pour les mains',
          ar: 'نعومته على اليدين',
        },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: "L'efficacité et le confort d'utilisation peuvent aller de pair.",
      ar: 'يمكن الجمع بين الفعالية والراحة أثناء الاستعمال.',
    },
    tip: {
      fr: 'Un bon liquide vaisselle doit être efficace tout en restant agréable à utiliser.',
      ar: 'يجب أن يكون سائل غسل الأواني الجيد فعالاً ومريحاً أثناء الاستعمال.',
    },
  },
  {
    id: 19,
    question: {
      fr: 'Les mains sont sollicitées :',
      ar: 'تُستعمل اليدان:',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: 'Une fois par semaine',
          ar: 'مرة في الأسبوع',
        },
      },
      {
        id: 2,
        text: {
          fr: 'Une fois par mois',
          ar: 'مرة في الشهر',
        },
      },
      {
        id: 3,
        text: {
          fr: 'Tous les jours',
          ar: 'كل يوم',
        },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: 'Prendre soin de ses mains est important car elles sont utilisées dans presque toutes les activités quotidiennes.',
      ar: 'العناية باليدين مهمة لأنهما تُستخدمان في معظم الأنشطة اليومية.',
    },
    tip: {
      fr: 'Protégez et hydratez régulièrement vos mains.',
      ar: 'احمِ يديك ورطبهما بانتظام.',
    },
  },
  {
    id: 20,
    question: {
      fr: 'Un liquide vaisselle doux aide à :',
      ar: 'يساعد سائل غسل الأواني اللطيف على:',
    },
    answers: [
      {
        id: 1,
        text: {
          fr: 'Colorer les mains',
          ar: 'تلوين اليدين',
        },
      },
      {
        id: 2,
        text: {
          fr: 'Les rendre grasses',
          ar: 'جعلهما دهنيتين',
        },
      },
      {
        id: 3,
        text: {
          fr: 'Préserver leur douceur',
          ar: 'الحفاظ على نعومتهما',
        },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: "Une formule douce améliore l'expérience d'utilisation au quotidien.",
      ar: 'تجعل التركيبة اللطيفة تجربة الاستخدام اليومية أكثر راحة.',
    },
    tip: {
      fr: 'Privilégiez une formule adaptée à une utilisation quotidienne.',
      ar: 'اختر تركيبة مناسبة للاستخدام اليومي.',
    },
  },
  {
    id: 21,
    question: {
      fr: 'AIGLE est une marque :',
      ar: 'AIGLE علامة:',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'Américaine', ar: 'أمريكية' },
      },
      {
        id: 2,
        text: { fr: 'Italienne', ar: 'إيطالية' },
      },
      {
        id: 3,
        text: { fr: 'Algérienne', ar: 'جزائرية' },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: 'AIGLE fait partie des marques développées par Univers Détergent pour les foyers algériens.',
      ar: 'AIGLE من العلامات التي طورتها شركة Univers Détergent للعائلات الجزائرية.',
    },
    tip: {
      fr: 'AIGLE est développée pour répondre aux besoins quotidiens des foyers algériens.',
      ar: 'تم تطوير AIGLE لتلبية الاحتياجات اليومية للعائلات الجزائرية.',
    },
  },
  {
    id: 22,
    question: {
      fr: 'Univers Détergent est spécialisée dans :',
      ar: 'تتخصص شركة Univers Détergent في:',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'Les téléphones', ar: 'الهواتف' },
      },
      {
        id: 2,
        text: { fr: 'Les meubles', ar: 'الأثاث' },
      },
      {
        id: 3,
        text: {
          fr: "Les produits d'entretien",
          ar: 'منتجات التنظيف والعناية المنزلية',
        },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: "L'entreprise développe plusieurs marques destinées à l'entretien et à l'hygiène du foyer.",
      ar: 'تطوّر الشركة عدة علامات مخصصة لتنظيف المنزل والمحافظة على نظافته.',
    },
    tip: {
      fr: "Les produits du groupe couvrent différents besoins d'entretien du foyer.",
      ar: 'تغطي منتجات المجموعة احتياجات مختلفة للعناية بالمنزل.',
    },
  },
  {
    id: 23,
    question: {
      fr: 'Quelle autre marque appartient à Univers Détergent ?',
      ar: 'ما العلامة الأخرى التابعة لشركة Univers Détergent؟',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'Toyota', ar: 'تويوتا' },
      },
      {
        id: 2,
        text: { fr: 'Samsung', ar: 'سامسونغ' },
      },
      {
        id: 3,
        text: { fr: 'Ours Blanc', ar: 'Ours Blanc' },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: 'Univers Détergent commercialise également Ours Blanc et Wave.',
      ar: 'تسوّق شركة Univers Détergent أيضاً علامتي Ours Blanc وWave.',
    },
    tip: {
      fr: 'Univers Détergent possède plusieurs marques complémentaires.',
      ar: 'تمتلك Univers Détergent عدة علامات متكاملة.',
    },
  },
  {
    id: 24,
    question: {
      fr: "Quelle autre marque de l'entreprise est connue pour l'entretien des sols ?",
      ar: 'ما العلامة الأخرى التابعة للشركة والمعروفة بمنتجات تنظيف الأرضيات؟',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'AIGLE', ar: 'AIGLE' },
      },
      {
        id: 2,
        text: { fr: 'Ours Blanc', ar: 'Ours Blanc' },
      },
      {
        id: 3,
        text: { fr: 'Wave', ar: 'Wave' },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: 'Wave propose différentes fragrances destinées à parfumer et nettoyer les sols.',
      ar: 'تقدم Wave روائح مختلفة مخصصة لتعطير الأرضيات وتنظيفها.',
    },
    tip: {
      fr: 'Choisissez une fragrance Wave adaptée à votre intérieur.',
      ar: 'اختر من Wave الرائحة المناسبة لمنزلك.',
    },
  },
  {
    id: 25,
    question: {
      fr: "L'objectif d'Univers Détergent est de proposer :",
      ar: 'يتمثل هدف Univers Détergent في تقديم:',
    },
    answers: [
      {
        id: 1,
        text: { fr: 'Des jeux vidéo', ar: 'ألعاب فيديو' },
      },
      {
        id: 2,
        text: { fr: 'Des vêtements', ar: 'ملابس' },
      },
      {
        id: 3,
        text: {
          fr: "Des solutions d'entretien pour le foyer",
          ar: 'حلول للعناية بالمنزل',
        },
      },
    ],
    correctAnswer: 3,
    explanation: {
      fr: "L'innovation et la qualité sont au cœur du développement des produits du groupe.",
      ar: 'يقع الابتكار والجودة في صميم تطوير منتجات المجموعة.',
    },
    tip: {
      fr: "Les marques du groupe proposent des solutions adaptées aux besoins quotidiens du foyer.",
      ar: 'تقدم علامات المجموعة حلولاً تتناسب مع الاحتياجات اليومية للمنزل.',
    },
  },
];